import { render, staticRenderFns } from "./faceStudentSearch.vue?vue&type=template&id=0a0944b6&scoped=true"
import script from "./faceStudentSearch.vue?vue&type=script&lang=js"
export * from "./faceStudentSearch.vue?vue&type=script&lang=js"
import style0 from "./faceStudentSearch.vue?vue&type=style&index=0&id=0a0944b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0944b6",
  null
  
)

export default component.exports